
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <!-- <h1>Library</h1> -->
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Library</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
          
      <div class="container-fluid">

        <div class="row">
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-info"><i class="far fa-envelope"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Borrowed</span>
                <span class="info-box-number">{{infocount.ttlbooksisued}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-success"><i class="far fa-flag"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Due</span>
                <span class="info-box-number">{{infocount.duebkscnt}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-warning"><i class="far fa-copy"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Visits</span>
                <span class="info-box-number">{{infocount.libvisitcnt}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-danger"><i class="far fa-star"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Hours Spent</span>
                <span class="info-box-number">{{infocount.vishrs}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
        </div>

        <div class="row">
         


              
          <!-- /.col -->
          <div class="col-md-9">
            <div class="card card-danger card-outline">
              <div class="card-header p-2">
                <ul class="nav nav-pills">
                  <li class="nav-item"><a class="nav-link active" (click)="booksb0rowed_infocont()" href="#borrowed" data-toggle="tab">Borrowed </a></li>
                  <li class="nav-item"><a class="nav-link" (click)="opac('seltop10opac',0,'')" href="#opac" data-toggle="tab">OPAC </a></li>
                  <li class="nav-item"><a class="nav-link" (click)="elinks('seltopelink',0,'')" href="#elinks" data-toggle="tab">E-Links</a></li>
                  <li class="nav-item"><a class="nav-link" (click)="qbanks('seltopqbank',0,'')" href="#qbank" data-toggle="tab">Question Bank</a></li>
                </ul>
              </div><!-- /.card-header -->
              <div class="card-body">
                <div class="tab-content">
                  <div class="active tab-pane" id="borrowed">
                    <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 10px">#</th>
                            <th>Book info</th>
                            
                            <th style="width: 120px"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let book of bookslst; let i=index; ">
<td>{{i+1}}</td>
                            <td style="line-height:24px;">
                              <p style="margin-bottom: 0px;"><span style="margin-bottom: 0px;color: purple;font-weight: bold;font-size: 17px;">{{book.title}}</span> | <span style="color: black;" > Acc No. : {{book.accno}} </span>  <span *ngIf="book.edition!=''" style="color: blue;"> | Edition : {{book.edition}}</span> <br>            
                                  
                                <span> Issued Date : {{book.isdt| date: 'dd-MM-yyyy'}} </span> | <span> Due Date : {{book.duedt| date: 'dd-MM-yyyy'}} </span>  <span *ngIf="book.status=='Returned' "> | Returned Date : {{book.retdt| date: 'dd-MM-yyyy'}} </span>
                           
                            </p>
                          </td>
                          <td><span class="badge" [ngClass]="{'bg-danger': book.status=='Due', 'bg-success': book.status=='Issued','bg-primary':book.status=='Returned' }">{{book.status}}</span>
                          <br>

                          <span style="color:red;font-size: 12px;" *ngIf="book.status=='Due'">Lapsed by{{book.duecount}} days</span>
                          <span style="color:green;font-size: 12px" *ngIf="book.status=='Issued'">Remaining-{{book.duecount}} days</span>
                          </td>   
                          </tr>
                         
                        </tbody>
                      </table>
                 
                    <!-- /.post -->
                  </div>
                  <!-- /.tab-pane -->
                  <div class="tab-pane" id="opac">
                    <div class="input-group">
                      <i class="fa fa-search srch"></i> <input type="text" class="form-control" placeholder="Search" (keyup)="seropac(($event.target.value))">
                      <!-- <div class="input-group-btn">
                        <button class="btn btn-default" type="submit">
                          <i class="fa fa-search"></i>
                        </button>
                      </div> -->
                    </div>  
                    <!-- <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 10px">#</th>
                            <th>Task</th>
                            <th>Progress</th>
                            <th style="width: 40px">Label</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1.</td>
                            <td>Update software</td>
                            <td>
                              <div class="progress progress-xs">
                                <div class="progress-bar progress-bar-danger" style="width: 55%"></div>
                              </div>
                            </td>
                            <td><span class="badge bg-danger">55%</span></td>
                          </tr>
                          <tr>
                            <td>2.</td>
                            <td>Clean database</td>
                            <td>
                              <div class="progress progress-xs">
                                <div class="progress-bar bg-warning" style="width: 70%"></div>
                              </div>
                            </td>
                            <td><span class="badge bg-warning">70%</span></td>
                          </tr>
                          <tr>
                            <td>3.</td>
                            <td>Cron job running</td>
                            <td>
                              <div class="progress progress-xs progress-striped active">
                                <div class="progress-bar bg-primary" style="width: 30%"></div>
                              </div>
                            </td>
                            <td><span class="badge bg-primary">30%</span></td>
                          </tr>
                          <tr>
                            <td>4.</td>
                            <td>Fix and squish bugs</td>
                            <td>
                              <div class="progress progress-xs progress-striped active">
                                <div class="progress-bar bg-success" style="width: 90%"></div>
                              </div>
                            </td>
                            <td><span class="badge bg-success">90%</span></td>
                          </tr>
                        </tbody>
                      </table> -->
                      <!-- <perfect-scrollbar style=" max-height: 300px;max-width: 500px;" [config]="{useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: false}"> -->
                      <!-- <div style="height: 300px;overflow-y: scroll;">  -->
                        <virtual-scroller #scroll style="
                        height: 280px;" >
                      <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 10px">#</th>
                            <th>Details</th>
                            
                            <th style="width: 50px"></th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let book of arropac; let i=index; ">
<td>{{i+1}}</td>
                            <td style="line-height:24px;">
                              <p style="margin-bottom: 0px;"><span style="margin-bottom: 0px;color: purple;font-weight: bold;font-size: 17px;">
                                {{book.title}}</span> | <span style="color: black;" > Acc No. : {{book.accno}} </span>  <br>            
                                  
                                 <span *ngIf="book.author!=''" style="color: blue;">  Author : {{book.author}}</span> <span *ngIf="book.edition!=''" style="color: blue;"> | Edition : {{book.edition}}</span><br>
                                 <span *ngIf="book.pubnm!='' || book.pbnm!=null" > Publisher : {{book.pubnm}} </span>
                           
                            </p>
                          </td>
                          <td>
                            <!-- <span class="badge" [ngClass]="{'bg-danger': book.status=='Due', 'bg-success': book.status=='Issued','bg-primary':book.status=='Returned' }">{{book.status}}</span>
                          <br>

                          <span style="color:red;font-size: 12px;" *ngIf="book.status=='Due'">Lapsed by{{book.duecount}} days</span>
                          <span style="color:green;font-size: 12px" *ngIf="book.status=='Issued'">Remaining-{{book.duecount}} days</span> -->
                          </td>   
                          </tr>
                         
                        </tbody>
                      </table>
                    </virtual-scroller>
                    <!-- </div>  -->
                    
                    <!-- </perfect-scrollbar> -->
                    </div>
                  <!-- /.tab-pane -->

                  <div class="tab-pane" id="elinks">
                    <div class="input-group">
                      <i class="fa fa-search srch"></i> <input type="text" class="form-control" placeholder="Search" (keyup)="serelink(($event.target.value))">
                      <!-- <div class="input-group-btn">
                        <button class="btn btn-default" type="submit">
                          <i class="fa fa-search"></i>
                        </button>
                      </div> -->
                    </div>  
                    
                        <virtual-scroller #scroll style="
                        height: 280px;" >
                        <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 10px">#</th>
                            <th>Details</th>
                            
                            

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let book of arrelink; let i=index; ">
<td>{{i+1}}</td>
                            <td style="line-height:24px;">
                              <p style="margin-bottom: 0px;"><span style="margin-bottom: 0px;color: purple;font-weight: bold;font-size: 17px;">
                                {{book.resdesc}}</span>  <br>            
                                  
                                   <a style="color: blue;" href="{{book.reslink}}" target="_blank"><i class="fa fa-link"></i> {{book.reslink}}</a> 
                           
                            </p>
                          </td>
                           
                          </tr>
                         
                        </tbody>
                      </table>
                    </div>
                    </virtual-scroller>
                  </div>
                  <!-- /.tab-pane -->
                  
                  <div class="tab-pane" id="qbank">
                    <div class="input-group">
                      <i class="fa fa-search srch"></i> <input type="text" class="form-control" placeholder="Search" (keyup)="serqbank(($event.target.value))">
                      <!-- <div class="input-group-btn">
                        <button class="btn btn-default" type="submit">
                          <i class="fa fa-search"></i>
                        </button>
                      </div> -->
                    </div>  
                    
                        <virtual-scroller #scroll style="
                        height: 280px;" >
                      <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 10px">#</th>
                            <th>Details</th>
                            
                            <th style="width: 50px">#</th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let book of arrqbank; let i=index; ">
<td>{{i+1}}</td>
                            <td style="line-height:24px;">
                              <p style="margin-bottom: 0px;"><span style="margin-bottom: 0px;color: purple;font-weight: bold;font-size: 17px;">
                                {{book.qbtitle}}</span> | <span style="color: blue;" > Month/Year : {{book.qbmonth}}/{{book.qbyear}} </span> <br>            

                                <span style="color: black;" > Course : {{book.crnm}} </span> | <span style="color: black;" > Sem : {{book.clnm}} </span> | <span style="color: black;" > Subject : {{book.subnm}} </span>
                                  
                                  
                           
                            </p>
                          </td>
                          <td>

                            <a href="http://43.247.158.94:8081/mycampuz/{{book.docpath}}" target="_blank" download><i class="fa fa-file-download"></i></a>
                          </td>
                           <!-- <td><i class="fa fa-file-download" (click)="<a href="http://43.247.158.94:8081/mycampuz/{{book.docpath}}" download>"></i></td> -->
                          </tr>
                         
                        </tbody>
                      </table>
                    </virtual-scroller>
                  </div>
                  <!-- /.tab-pane -->
                </div>
                <!-- /.tab-content -->
              </div><!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->

          <div class="col-md-3">

        
            <!-- About Me Box -->
            <div class="card card-danger card-outline">
              <div class="card-header">
                <h3 class="card-title">Useful Links</h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <strong><i class="fas  fa-lock mr-1"></i>Abacus</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p>

                <hr>

                <strong><i class="fas fa-pencil-alt mr-1"></i> Vedic Maths</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p>
                 <hr>
                <strong><i class="far fa-file-alt mr-1"></i> Art & Craft</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p>
               

               

              
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div><!-- /.container-fluid -->
      
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->